import React from "react";
import pk from "../../../img/profileImg/dialogs/pk.png";
const DialogsMessages = ({id, sender, text, users}) => {
    return (
        <div className={!sender ? "dialogs__your-message dialogs__message" : "dialogs__message"}>
            <div className="dialogs__message-img"><img src={sender ? users[sender - 1].img : pk} alt=""/></div>
            <p>{text}</p>
        </div>

    )
};

export default DialogsMessages